






















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Branding } from '@/api/model/branding'

@Component
export default class EditBrandingForm extends Vue {
    @Prop({ required: true }) branding!: Branding
}
